// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Clip = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 24 55" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M2 45.288a1 1 0 1 1-2 0V12.905C0 6.17 5.244.64 11.68.64c6.438-.002 11.68 5.525 11.683 12.266v14.762a148886.017 148886.017 0 0 1-.003 18.382c-.003 4.473-3.846 8.099-8.519 8.099-4.67.003-8.512-3.63-8.509-8.102-.003-4.423-.002-11.146.003-15.228-.005-4.075-.006-9.842-.003-12.703.003-3.061 2.395-5.58 5.35-5.58 2.952.004 5.346 2.522 5.346 5.58l-.001 4.912v.983c0 1.987 0 3.274-.002 4.4 0 1.376 0 2.744.002 4.04v1.23l.001.452a1 1 0 1 1-2 .002v-.452l-.001-1.23a6397.95 6397.95 0 0 1 0-8.442v-.983l.001-4.914c0-1.974-1.523-3.575-3.348-3.577-1.825 0-3.346 1.6-3.348 3.581-.003 2.86-.002 8.625.003 12.701a9825.01 9825.01 0 0 0-.003 15.228c-.002 3.341 2.92 6.104 6.509 6.102 3.594 0 6.517-2.758 6.52-6.1a22119.257 22119.257 0 0 0 .002-18.381V12.906c-.003-5.66-4.374-10.269-9.683-10.267C6.373 2.64 2 7.25 2 12.905v32.383Z"
			fill="#FFF"
			fillRule="nonzero"
		/>
	</svg>
);
export default Clip;
